import React from 'react'
import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'

const LayoutRightSidebar = ({
  align = 'center',
  children,
  content,
  gridSize = {
    children: 6,
    content: 6
  }
}) => (
  <Grid spacing={{ x: 1.5, y: 1 }} align={align}>
    <GridColumn md={gridSize.content}>
      {content}
    </GridColumn>
    <GridColumn md={gridSize.children}>
      {children}
    </GridColumn>
  </Grid>
)

export default LayoutRightSidebar
